document.addEventListener('DOMContentLoaded', function() {
    const quantityControls = document.querySelectorAll('.product__quantity');
    
    quantityControls.forEach(control => {
        const input = control.querySelector('.product__count');
        const minusBtn = control.querySelector('.quantity__btn--minus');
        const plusBtn = control.querySelector('.quantity__btn--plus');
        
        if (!input || !minusBtn || !plusBtn) return;
        
        minusBtn.addEventListener('click', function() {
            const currentValue = parseInt(input.value) || 1;
            const minValue = parseInt(input.min) || 1;
            if (currentValue > minValue) {
                input.value = currentValue - 1;
            }
        });
        
        plusBtn.addEventListener('click', function() {
            const currentValue = parseInt(input.value) || 1;
            const maxValue = parseInt(input.max) || Infinity;
            if (currentValue < maxValue) {
                input.value = currentValue + 1;
            }
        });
    });
});